import * as React from 'react';
// import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { AntdConfigProvider, IntlProvider, RouteTree, PermissionContext } from '@/components';
import store from '@/stores/index';

// 声明 window.CONFIG 类型
declare global {
  interface Window {
    CONFIG?: {
      FMS_LOCATION?: {
        INVOICE?: string;
        [key: string]: any;
      };
      [key: string]: any;
    };
  }
}

const App = observer(() => {

  return (
    <AntdConfigProvider locale={store.locale} >
      <IntlProvider locale={store.locale}>
        <PermissionContext.Provider value={{
          routePermission: store.menuList,
          pageElementPermission: store.pageElements,
        }}>
          <RouteTree />
        </PermissionContext.Provider>
      </IntlProvider>
    </AntdConfigProvider>
  );
});

export default App;
